import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractModal } from '../abstract-modal';
import { ModalService } from '../../../services/modal.service';
import { ConfirmationModal } from '../../../classes/modal.class';
import { ConfirmationModalData } from 'src/app/models/modal.interface';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationModalComponent extends AbstractModal {

  modal: ConfirmationModal;

  constructor(
    modalService: ModalService,
    public sanitizer: DomSanitizer
  ) {
    super(modalService);
  }

  get data(): ConfirmationModalData {
    return this.modal.data;
  }

  confirm(): void {
    if (!this.data.form) {
      this.data.confirm();
      this.closeModal();
      return;
    }
    if (!this.data.form.valid) {
      this.data.form.markAllAsTouched();
      return;
    }
    this.data.confirm(this.modal);
    this.closeModal();
  }

  close(): void {
    if (this.data.close) {
      this.data.close();
    }

    this.closeModal();
  }

  onChecked(checked: boolean, index: number): void {
    this.data.list[index].checked = checked;
  }

  onSelectAllChange(checked: boolean): void  {
    this.data.list.forEach(job => job.checked = checked);
  }

  selectAllChecked(): boolean {
    return this.data.list.every(job => job.checked);
  }
}
